var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-brokers-with-refresh__wrapper"},[_c('a-top-brokers',{key:_vm.$_lazyHydratedComponentState_getHydratedComponentRefreshKey(
        _vm.$options.consts.HYDRATED_SECTION_NAME
      ),attrs:{"sidebar-layout":_vm.sidebarLayout,"top-brokers":_vm.topBrokers},on:{"mounted":_vm.onMounted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }